import { useState, useEffect } from 'react';
import 'boxicons'
import menu_postre from '../img/postres.jpg';
import desayuno from '../img/desayuno.jpg';
import menu_bebidas from '../img/menu_bebidas.jpg';
import menu_sandwich from '../img/sandwich.jpg';
 
import Cargando from './Cargando';
import Menu from './Menu';
import Login from './login';
import SliderVertical from './SliderVertical';
import buenamozabistro_lugar2 from '../img/buenamozabistro_lugar2.jpg';
import buenamozabistro_lugar5 from '../img/buenamozabistro_lugar5.jpg';
import buenamozabistro_lugar3 from '../img/buenamozabistro_lugar3.jpg';
import Dashboard from './Site/dashboard'
function Index() {     
    const [token, setToken]=useState("");   
    const [formLogin, setformLogin]=useState(false);
    const [LoginOn, setLoginON]=useState(false);
    const [usuario, setUsuario]=useState("");
    const [clave, setClave]=useState("");
    const [nombre, setNombre]=useState("");
    const [perfil, setPerfil]=useState("");
    const [msgError, setMesgError]=useState("");
    const [showMenu, setShowMenu]=useState(true);
    const [showLoading, setShowLoading]=useState(false);

    const queryParameters = new URLSearchParams(window.location.search)
  
  useEffect(()=>{              
          const seccion = queryParameters.get("seccion")          
          if(seccion){
            if(seccion =='menu'){  
                setformLogin(false)
                setShowMenu(false)
            }
            if(seccion =='acceso'){
                setShowMenu(false)
                setformLogin(true)
            }
          }            
  },[queryParameters]) 


    const cerrarSesion=()=>{
        setformLogin(false)
        setUsuario('')
        setClave('')
        setNombre('')
        setLoginON(false)
    }

return (
    <>
        
       
        {showLoading && <Cargando/>    }            
        <div className='w-full mx-auto lg:5/6 bg-azul '>
            <nav className='items-end'>                
                <div className='links lg:block '>
                    <ul className='flex menu items-center justify-center gap-5'>                        
                        <li><a href='/' className='link' id='mobile-menu' onClick={()=>setShowMenu(true)}>Inicio</a></li>
                        <li><a href='/?seccion=menu' className='link' id='mobile-menu' onClick={()=>setShowMenu(false)}>Menu</a></li>    
                        {!LoginOn?                                                               
                            <li><a href='?seccion=acceso' className='link' id='mobile-menu' onClick={()=>setformLogin(true)}>Acceso</a></li>                                                                  
                        :
                            <li><a href='#' className='link' id='mobile-menu' onClick={()=>cerrarSesion()}>Salir</a></li>                                                                  
                        }
                    </ul>                  
                </div>                   
            </nav>
        </div>  

        {formLogin===true  && !LoginOn &&
            <Login setUsuario={setUsuario} usuario={usuario} clave={clave} setClave={setClave} setPerfil={setPerfil} setNombre={setNombre} setformLogin={setformLogin} setLoginON={setLoginON}/>
        }

        {LoginOn &&
        <>
            <div className='bg-dorado p-3 grid grid-cols-2 w-full'><h1 className=' text-white font-bold'>Bienvenid@: {nombre}</h1></div>
        </>
        }     

        {showMenu ? 
        <div>
         <div className='mx-auto p-3 flex-col justify-center flex md:flex-row content-center'>                            
            <div clasename='justify-center'>
                <a href="#"><img src={menu_bebidas} width={"100%"}      className='pb-2 md:p-2 lg:pt-5' onClick={()=>setShowMenu(!showMenu)} />  </a>          
            </div> 
            <div clasename='justify-center'>
                <a href='#'><img src={menu_postre}  width={"100%"}      className='pb-2 md:pt-2 lg:pt-5'onClick={()=>setShowMenu(!showMenu)} /></a>
                <a href='#'><img src={desayuno}  width={"100%"}         className='pb-2 md:pt-2 lg:pt-1'onClick={()=>setShowMenu(!showMenu)} /></a>
            </div>
            <div clasename='justify-center '>
                <a href='#'><img src={menu_sandwich}  width={"100%"}    className='pb-2 md:p-2  lg:pt-5'onClick={()=>setShowMenu(!showMenu)} /></a>
            </div>                
        </div>
        <div className='mx-auto p-10 flex-col justify-center flex md:flex-row content-center m-5 cursor-pointer ' onClick={()=>setShowMenu(!showMenu)}>  
            <SliderVertical setShowMenu={setShowMenu} showMenu={showMenu} />           
        </div>
        {/* <div className='w-full bg-dorado p-5'>
            <h1 className='text-white text-lg'>Nuestro lugar</h1>
        </div> */}
        <div className=' content-center m-5  md:flex items-center mt-5 cursor-pointer' onClick={()=>setShowMenu(!showMenu)}>
            
            <div className=' bg-white content-center p-5 round m-3 align-middle'>
                <img src={buenamozabistro_lugar2}/>
            </div>
            <div className=' bg-white content-center p-5 round m-3 align-middle'>
                <img src={buenamozabistro_lugar5}/>
            </div>
            <div className=' bg-white content-center p-5 round m-3 text-center align-middle'>
                <img className='mx-auto' src={buenamozabistro_lugar3}/>
            </div>
            
        </div>
          
          
        </div> 
        :
        <Menu setShowLoading={setShowLoading} LoginOn={LoginOn}/>
        }

        
    </>
    );
}
export default Index;